import SlimSelect from "slim-select";

import { __, _x, _n, _nx } from "@wordpress/i18n";

const dateFilter = () => {
  const filter = document.getElementById('order-filter');

  if(filter) {
    new SlimSelect({
      placeholder: _x('date order', 'select filter', 'themosis'),
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {
      location.href = this.value;
    });
  }
}

const branchFilter = () => {
  const filter = document.getElementById('branch-filter');

  if(filter) {
    new SlimSelect({
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {
      location.href = this.value;
    });
  }
}

const eventTimeframeFilter = () => {
  const filter = document.getElementById('event-timeframe-filter');

  if(filter) {
    new SlimSelect({
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {
      location.href = this.value;
    });
  }
}

const itemsPerPageFilter = () => {
  const filter = document.getElementById('items-per-page-filter');

  if(filter) {
    new SlimSelect({
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {
      location.href = this.value;
    });
  }
}

const wishCategoryFilter = () => {
  const filter = document.getElementById('wish-category-filter');

  if(filter) {
    new SlimSelect({
      placeholder: _x('wish category', 'select filter', 'themosis'),
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {
      location.href = this.value;
    });
  }
}

const donationFrequency = () => {
  const filter = document.getElementById('donation-frequency');

  if(filter) {
    new SlimSelect({
      select: filter,
      showSearch: false,
    });

    $(filter).on('change', function() {

      // location.href = this.value;
    });
  }
}

export const select = () => {
  dateFilter();
  branchFilter();
  eventTimeframeFilter();
  itemsPerPageFilter();
  wishCategoryFilter();
  donationFrequency();
};
